/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { request } from '.';
import type { RequestParams } from './http-client';

import type {
  Errors,
  FeatureCategories,
  GetCategorizedFeaturesParams,
  GetCategorizedHighlightedFeaturesParams,
} from './data-contracts';
// api

/**
 * @description Provides title, description and image URL for each requested feature equipment and returns them in a categorized tree.
 *
 * @tags 1 - Features
 * @name GetCategorizedFeatures
 * @summary Endpoint for categorized equipment features.
 * @request GET:/api/v1/features/country/{country}/language/{language}/model-series/{model-series}/equipments/{equipment-ids}/categorized
 */
export const getCategorizedFeatures = (
  { country, language, modelSeries, equipmentIds, ...query }: GetCategorizedFeaturesParams,
  params: RequestParams = {},
) =>
  request<FeatureCategories, Errors>({
    path: `/api/v1/features/country/${country}/language/${language}/model-series/${modelSeries}/equipments/${equipmentIds}/categorized`,
    method: 'GET',
    query: query,
    format: 'json',
    ...params,
  });
/**
 * @description Provides title, description and image URL for each highlighted feature equipment and returns them in a categorized tree. Equipment shown in the exterior and interior section, are filtered here to avoid duplication.
 *
 * @tags 1 - Features
 * @name GetCategorizedHighlightedFeatures
 * @summary Endpoint for highlighted categorized equipment features.
 * @request GET:/api/v1/features/country/{country}/language/{language}/model-series/{model-series}/highlights
 */
export const getCategorizedHighlightedFeatures = (
  { country, language, modelSeries, ...query }: GetCategorizedHighlightedFeaturesParams,
  params: RequestParams = {},
) =>
  request<FeatureCategories, Errors>({
    path: `/api/v1/features/country/${country}/language/${language}/model-series/${modelSeries}/highlights`,
    method: 'GET',
    query: query,
    format: 'json',
    ...params,
  });
